import React, { useState } from "react";
import { MainLayoutAdmin } from "../../../layout/MainLayoutAdmin";
import { useNavigate } from "react-router-dom";
import {HOST} from '../../../config';

function ResourceUpload() {
  const [selectedFile, setSelectedFile] = useState();
  const [disableBtn, setDisableBtn] = useState(false);

  const navigate = useNavigate();

  function changeHandler(event) {
    setSelectedFile(event.target.files[0]);
  }

  function handleSave() {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/admin/login");
    }

    const myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );

    const formdata = new FormData();
    formdata.append("file", selectedFile);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    setDisableBtn(true);
    fetch(`${HOST}/resource/upload`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const res = JSON.parse(result);
        setDisableBtn(false);
        if (res.id) {
          alert('Tạo thành công')
          navigate(`/admin/resource`)
        } else {
          alert('Tạo không thành công')
        }
      })
      .catch((error) => console.log("error", error));
  }

  return (
    <MainLayoutAdmin>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="align-middle inline-block min-w-full">
            <div className="shadow overflow-hidden p-2">
              <div className="mb-6">
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                  Chọn file
                </label>
                <input
                  onChange={changeHandler}
                  type="file"
                  name="file"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
              <button
                disabled={disableBtn}
                onClick={handleSave}
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                {disableBtn ? 'Đang tải lên': 'Tải lên'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayoutAdmin>
  );
}

export default ResourceUpload;
